import { CartLine } from '@msdyn365-commerce/retail-proxy';
import { IProductInventoryInformation } from '../actions/utilities/product-inventory-information';

/**
 * Finds matching cart line for a product. For CNC (click & collect) items,
 * only matches lines with a fulfillment store assigned.
 */
const findCartLine = (cartLines: CartLine[], productId: number, isCNCItem: boolean, storeId?: string): CartLine | undefined => {
    return cartLines.find(line => line.ProductId === productId && (!isCNCItem || line.FulfillmentStoreId === storeId));
};

/**
 * Checks if adding the requested quantity would exceed available inventory.
 * Used to validate quantity before add-to-cart or quantity update.
 */
export const checkIsOverMaxInventoryQuantity = (
    quantity: number,
    cartLines: CartLine[],
    productId: number,
    isCNCItem: boolean,
    inventory?: IProductInventoryInformation,
    storeId?: string
): boolean => {
    const cartLine = findCartLine(cartLines, productId, isCNCItem, storeId);
    const maxQuantity = inventory?.ProductAvailableQuantity?.AvailableQuantity ?? 0;
    // Need to account for what's already in cart
    const currentQuantityInCart = cartLine?.Quantity ?? 0;

    return quantity + currentQuantityInCart > maxQuantity;
};
